export const priceValidationStatuses = {
  equal: "equal",
  updated: "updated",
  increased: "increased",
  decreased: "decreased",
  earlierDate: "earlierDate",
  laterDate: "laterDate",
  error: "error",
  notDefined: "notDefined",
} as const;
